import React from 'react';

class TransactionsData {
    constructor(type, navigate,) {
        this.type = type;
        this.navigate = navigate;
    }

    header() {
        return (
            <>
                {this.type === 'IMAGE' && <th>Preview</th>}
                {(this.type === 'ITEM_SELL' || this.type === 'ITEM_BUY') && <th>Item</th>}
                {this.type === 'CHAT_MESSAGE' && <th>Message</th>}
            </>
        );
    }

    onClick(transaction) {
        if (this.type === 'IMAGE') {
            this.navigate(`/image/profile/${transaction.resourceId}`);
        }
        if (this.type === 'ITEM_BUY' || this.type === 'ITEM_SELL') {
            this.navigate(`/items-detail/${transaction.resourcePreview}/graph`);
        }
    }
}

export default TransactionsData;
